<script>
import axios from "axios";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "faq",

  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}faq/`)
      .then((response) => {
        this.questionsData = response.data;
        this.isLoading = false;
      })
      .catch(() => {
        console.log("Ошибка при загрузке данных");
        this.isLoading = false;
      });
  },

  data() {
    return {
      activeQuestion: null,
      questionsData: [],
      isLoading: true,
    };
  },
  methods: {
    toggleAnswer(index) {
      if (this.activeQuestion === index) {
        this.activeQuestion = null;
      } else {
        this.activeQuestion = index;
      }
    },
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
    },
    leave(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    }
  }
};
</script>

<template>
  <div class="faq_container">
    <p class="faq_main_text" @click="activeQuestion = null">
      FAQ
    </p>
    <div class="question_container">
      <div v-for="(question, index) in questionsData" :key="index" @click="toggleAnswer(index)">
        <div :class="activeQuestion === index ? 'faq_item_main_active' : 'faq_item_main'">
          {{ question.question }}
        </div>
        <transition
          name="slide"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <p v-show="activeQuestion === index" class="faq_item" v-html="question.answer"></p>
        </transition>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/base.scss";

.faq_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $dg2;
  align-items: center;
  margin-top: 3%;
  width: 100%;
  border-radius: 10px;
  flex-wrap: wrap;
  padding: 3%;
}

.question_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

@media screen and (max-width: 767px) {
  .faq_container {
    width: 90%;
  }
}

.faq_item_main {
  color: $text_color;
  font-size: 20px;
  padding: 5px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.faq_item_main:hover {
  color: $text_color;
  text-shadow: 0 0 5px #6F7199, 0 0 10px white;
  border-bottom: 2px solid transparent;
  position: relative;
}

.faq_item_main_active {
  color: white;
  font-size: 20px;
  text-align: center;
  opacity: 20%;
  border-bottom: 2px solid transparent;
  position: relative;
  cursor: pointer;
}

.faq_item {
  overflow: hidden;
  color: $text_color;
  font-size: 15px;
  padding: 10px 5px;
  box-sizing: border-box;
}

.slide-enter-active,
.slide-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}

.faq_main_text {
  font-size: 50px;
  color: $text_color;
  font-weight: bold;
  text-shadow: 0 0 5px #6F7199, 0 0 10px white;
  border-bottom: 2px solid transparent;
  position: relative;
  margin-bottom: 3%;
  cursor: pointer;
}

.faq_main_text::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px;
  height: 3px;
  background-color: rgba(162, 191, 255, 0.8);
  box-shadow: 0 0 10px #4f58d8, 0 0 30px #7f83cd;
  border-radius: 2px;
  transform: scaleX(1);
  transition: transform 0.3s;
}

.faq_main_text:hover::after {
  transform: scaleX(2);
}


</style>
